import { render, staticRenderFns } from "./matchDetail.vue?vue&type=template&id=3a721efc&"
import script from "./matchDetail.vue?vue&type=script&lang=js&"
export * from "./matchDetail.vue?vue&type=script&lang=js&"
import style0 from "./matchDetail.vue?vue&type=style&index=0&id=3a721efc&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/zhishengluo/opp-scratch/scratch/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a721efc')) {
      api.createRecord('3a721efc', component.options)
    } else {
      api.reload('3a721efc', component.options)
    }
    module.hot.accept("./matchDetail.vue?vue&type=template&id=3a721efc&", function () {
      api.rerender('3a721efc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/match/matchDetail.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/match/matchDetail.vue
// module id = IiAo
// module chunks = 0